module.exports = __webpack_public_path__ + "img/reorder-icon.51e9b936.svg";